import { CONFIG_CONTEXT } from '../../../enum/config-context.enum';
import { TunnelStep } from '../model/tunnel-step-type';
import { Configurators2DComponent } from '../../configurators-2d/configurators-2d.component';

export const FENCE_TUNNEL_STEPS: TunnelStep[] = [
  {
    component: Configurators2DComponent,
    context: CONFIG_CONTEXT.FENCE,
  },
];
